import { Box, Stepper, useSteps } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import KnowYourLevelCard from './KnowYourLevelCard';
import DashboardStepCard from './DashboardStepCard';
import { useNavigate } from 'react-router-dom';
import StepLayout from './StepLayout';
import { useUserProfile } from '../../../hooks/useUser';

interface Props {
	selectedCourse: string;
}
const DashboardSteps = ({ selectedCourse }: Props) => {
	const navigate = useNavigate();

	const { data: userProfile } = useUserProfile();

	const dashboardStepCardData = [
		{
			type: 'start-practice',
			header: 'Practice To Upskill',
			subheader: (
				<>
					Enhance your skills to open the
					<br />
					door to career possibilities
				</>
			),
			ctaText: 'Start Practicing',
		},
		{
			type: 'create-resume',
			header: 'Create Your Resume',
			subheader: (
				<>
					Craft a winning resume that
					<br />
					stands out.
				</>
			),
			ctaText: 'start creating',
		},
		{
			type: 'start-appying',
			header: 'Apply To Jobs',
			subheader: (
				<>
					Explore opportunities based on your <br /> newly acquired skills
				</>
			),
			ctaText: 'start applying',
		},
	];

	const [assessmentStatus, setAssessmentStatus] = React.useState('');
	const { activeStep, setActiveStep } = useSteps({
		index: 0,
		count: 4,
	});

	useEffect(() => {
		if (userProfile?.enrolments && userProfile?.enrolments.length <= 0) {
			navigate('/onboarding');
		}
	}, [userProfile?.enrolments]);

	useEffect(() => {
		if (assessmentStatus === 'GRADED' || assessmentStatus === 'COMPLETED') {
			setActiveStep(1);
		}
	}, [assessmentStatus]);

	const [showWaitingModal, setShowWaitingModal] = React.useState(false);

	React.useEffect(() => {
		if (assessmentStatus === 'COMPLETED') {
			setShowWaitingModal(true);
		} else {
			setShowWaitingModal(false);
		}
	}, [assessmentStatus]);

	return (
		<>
			<Box mt="16px" display={'grid'} gap="14px" position="relative">
				<Stepper index={activeStep} orientation="vertical" gap="0px" w="full">
					<StepLayout>
						{/*******************  Step 1 Know You Level *******************/}
						<KnowYourLevelCard
							showWaitingModal={showWaitingModal}
							setShowWaitingModal={setShowWaitingModal}
							setAssessmentStatus={setAssessmentStatus}
							selectedCourse={selectedCourse}
						/>
					</StepLayout>

					<StepLayout isLocked={assessmentStatus !== 'GRADED' && assessmentStatus !== 'COMPLETED'}>
						{/*******************  Step 2 Practice *******************/}
						<DashboardStepCard
							//@ts-ignore
							content={dashboardStepCardData[0]}
							courseId={selectedCourse}
							type="start-practice"
							isPrimary={true}
							isLocked={assessmentStatus !== 'GRADED' && assessmentStatus !== 'COMPLETED'}
							// ctaText={'Start Practicing'}
						/>
					</StepLayout>

					<StepLayout isLocked={assessmentStatus !== 'GRADED' && assessmentStatus !== 'COMPLETED'}>
						{/*******************  Step 3 Resume *******************/}
						{
							//@ts-ignore
							<DashboardStepCard content={dashboardStepCardData[1]} type="create-resume" isLocked={assessmentStatus !== 'GRADED'} />
						}
					</StepLayout>

					<StepLayout isLocked={assessmentStatus !== 'GRADED' && assessmentStatus !== 'COMPLETED'}>
						{/*******************  Step 4 Apply to Jobs *******************/}
						{
							//@ts-ignore
							<DashboardStepCard
								onCtaClick={() => {
									navigate('/resume');
								}}
								content={dashboardStepCardData[2]}
								type="start-appying"
								isLocked={assessmentStatus !== 'GRADED' && assessmentStatus !== 'COMPLETED'}
							/>
						}
					</StepLayout>
				</Stepper>
			</Box>
		</>
	);
};

export default DashboardSteps;
